<div class="layout-footer">
    <span class="font-medium ml-2">Narrathèque version 0.2</span>
</div>
